export const enum ScreenName {
  SALES = 'offer',
  CANCEL_OFFER = 'cancel_offer',
  UPSELL_DOUBLE_PDF = 'sub_upsell_doublepdf',
  UPSELL_LW_PDF = 'sub_upsell_lwpdf',
}

export const enum Events {
  SESSION_STARTED = 'session_start',
  ONBOARDING_PAGE_COMPLETED = 'onboarding_page_completed',
  AB_SEGMENT = 'ab_segment',
  SEGMENT_ACTIVATED = 'segment_activated',
  EMAIL_PAGE_SHOW = 'email_page_show',
  EMAIL_EXTRA_SCREEN_SHOW = 'email_extra_screen_show',
  EMAIL_PAGE_COMPLETED = 'email_page_completed',
  EMAIL_PAGE_ERROR = 'email_page_error',
  SALE_SCREEN_SHOW = 'plans_page_show',
  VIEW_PRICE = 'prices_viewed',
  PURCHASE_SHOW = 'subs_purchase_show',
  PAYMENT_METHOD_PAGE_SHOW = 'payment_method_page_show',
  SUBS_PURCHASE_CLOSE = 'subs_purchase_screen_close',
  PURCHASE_STARTED = 'subs_purchase_started',
  PURCHASE_COMPLETED = 'subs_purchase_completed',
  PURCHASE_FAILED = 'subs_purchase_failed',
  PREPAID_CARD_BLOCKED = 'prepaid_card_blocked',
  CHECKOUT_POPUP_SHOWN = 'checkout_popup_shown',
  CHECKOUT_POPUP_CLOSED = 'checkout_popup_closed',
  CREATE_ACCOUNT_PAGE = 'create_account_page',
  LOGIN_METHOD_SELECTED = 'login_method_selected',
  ACCOUNT_CREATED = 'account_created',
  ACCOUNT_CREATION_FAILED = 'account_creation_failed',
  SUPPORT_BTN_CLICK = 'support_btn_click',
  SCREEN_PRESENTED = 'screen_presented',
  IQ_CERTIFICATE_CLAIMED = 'iq_certificate_claimed',
  CTA_BTN_CLICKED = 'cta_btn_clicked',
  LW_REDIRECT_CLICKED = 'lw_redirect_clicked',
  LW_REDIRECT_SUCCEEDED = 'lw_redirect_succeeded',
  LW_REDIRECT_FAILED = 'lw_redirect_failed',
  LW_EMAIL_INIT_SUCCEEDED = 'lw_email_init_succeeded',
  LW_EMAIL_INIT_FAILED = 'lw_email_init_failed',
}

export type TPricesViewedParams = {
  method: string
  screenName: string
  email: string
  scrollLvl?: string
}

export type TPaymentMethodPageShownParams = {
  email: string
  screenName?: string
  method?: string
  btnLocation?: string
  btnName?: string
  scrollLvl?: string
}

export type TCtaBtnClickedParams = {
  email: string
  screenName: string
  btnLocation?: string
  btnName?: string
  scrollLvl?: string
}

export interface IPurchaseCommonProps {
  paymentSystem: string
  productId: string
  productName?: string
  priceDetails?: {
    price: number
    trial: boolean
    currency: string
    trialPrice?: number
  }
  paymentMethod?: string
  email?: string
  stripeAccount?: { accountId?: string; accountName?: string }
  screenName?: string
}

export type TPrepaidCardBlockedParams = IPurchaseCommonProps & {
  cardBrand?: string
  binCountry?: string | null
}

export const buildPurchaseProps = (
  p: IPurchaseCommonProps,
): Record<string, unknown> => ({
  payment_system: p.paymentSystem,
  product_id: p.productId,
  ...(p.productName && { product_name: p.productName }),
  ...(p.priceDetails && {
    price: p.priceDetails.price,
    trial: p.priceDetails.trial,
    currency: p.priceDetails.currency,
  }),
  ...(p.paymentMethod && { payment_method: p.paymentMethod }),
  ...(p.email && { email: p.email }),
  ...(p.stripeAccount?.accountId && {
    stripe_account_id: p.stripeAccount.accountId,
  }),
  ...(p.stripeAccount?.accountName && {
    stripe_account_name: p.stripeAccount.accountName,
  }),
  screen_name: p.screenName || ScreenName.SALES,
})

export const buildPrepaidCardBlockedProps = (
  p: TPrepaidCardBlockedParams,
): Record<string, unknown> => ({
  ...buildPurchaseProps(p),
  card_brand: p.cardBrand || 'unknown',
  bin_country: p.binCountry || 'unknown',
})
